/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppComponent1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import AppComponent from 'DesignSystem/AppComponent/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AppComponent1({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/Apps/Content/AppComponent",
  innerRef
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let componentValueData = fromData.useDataValue({ viewPath,
context: 'component',
})
  return (<React.Fragment
>
<AppComponent
  viewPath={`${viewPath}/AppComponent`}
 data="component"
 value={componentValueData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 innerRef={innerRef}
/>
{children}
</React.Fragment>)
}